import { Input } from 'antd';
import Text from 'components/Text';
import React from 'react';
import styled from 'styled-components';
import qbSignal from './signal';

const InputNote = () => {
  return (
    <InputNoteStyled className='section-wrapper'>
      <div className="section-label">NOTES</div>
      <Input.TextArea
        placeholder='Please enter...'
        value={qbSignal.note.value || ''}
        onChange={e => {
          qbSignal.note.value = e.target.value;
        }}
        rows={2}
      />
    </InputNoteStyled>
  );
};

export default InputNote;

const InputNoteStyled = styled.div`
  .label {
    color: #1D2129;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 133.333% */
    margin-bottom: 8px;
  }

  textarea {
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 133.333% */
    padding: 12px;
    border-radius: 2px;
    background: #FFF;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.10) inset;

    &:focus, &:active ,&:hover {
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.10) inset;
    }
  }
`;
